import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLanguage } from "./Context/LanguageContext";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import translations from "./translations";
import "../styles/singleProduct.css";

function SingleProduct() {
  const { productId } = useParams();
  const { language } = useLanguage(); // Get the selected language
  const [singleProduct, setSingleProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [editorInstance, setEditorInstance] = useState(null);
  const [productImage, setProductImage] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `https://cairomed-backend.vercel.app/api/products/getProduct/${productId}`
        );
        const responseData = await response.json();

        if (responseData) {
          setSingleProduct(responseData);
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProduct();
  }, [productId]);

  useEffect(() => {
    if (singleProduct?.Body) {
      // Destroy previous EditorJS instance before creating a new one
      if (editorInstance) {
        editorInstance.destroy();
      }

      const newEditor = new EditorJS({
        holder: "editor-body",
        readOnly: true,
        data: singleProduct.Body[language === "ar" ? "Arabic" : "English"],
        tools: {
           header: Header, 
           list: {
            class: List,
            inlineToolbar: true, // Optional
          },
           },
      });

      setEditorInstance(newEditor);
    }
  }, [singleProduct, language]);
  useEffect(() => {
    if (singleProduct?.Image) {
      setProductImage(singleProduct.Image);
    }
  }, [singleProduct]);
  if (isLoading) return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
    </div>
  );
  if (!singleProduct) return <p>Product not found.</p>;



  return (
    <>
    <section className="page-header">
          <div className="container">
            <div>
              <h1>{translations[language].heroSectionTitle}</h1>
              <h2>{translations[language].productsHeaderTitle}</h2>
              <p>
                {translations[language].productsHeaderParagraph}
              </p>
              <p>
                {translations[language].productsHeaderParagraph2}
              </p>
            </div>
          </div>
      </section>
      <div className="single-product-container ">
      <h2>{language === 'en' ? singleProduct.ProductNameEN : singleProduct.ProductNameAR}</h2>
        {/* Conditionally show Arabic or English body */}
        <div className="container">
        <div id="editor-body" className="editorjs"></div>
        {productImage ? (
  <picture>
    <img src={productImage} alt={singleProduct.ProductNameEN} width="300" />
  </picture>
) : (
  <p>No image available</p>
)}

        </div>
      </div>

      {/* <h3>{translations[language].description}</h3> */}
    </>
  );
}

export default SingleProduct;
